import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { ExtensionApiService } from "src/app/core/api/extension-api.service";
import { ExtensionReview } from "src/app/core/models/extension-review";

@Component({
    selector: "app-confirm-extension-modal",
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    templateUrl: "./confirm-extension-modal.component.html",
    styleUrl: "./confirm-extension-modal.component.scss",
})
export class ConfirmExtensionModalComponent implements OnInit {
    @Input() public extensionId: number;

    public review: ExtensionReview | null = null;
    public loading = true;

    constructor(
        private activeModal: NgbActiveModal,
        private extensionApiService: ExtensionApiService
    ) {}

    ngOnInit(): void {
        this.extensionApiService.getReview(this.extensionId).subscribe({
            next: (result) => {
                this.review = result;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    onConfirm(): void {
        this.activeModal.close(true);
    }

    onCancel(): void {
        this.activeModal.close(false);
    }
}
